import { render, staticRenderFns } from "./AssignmentDialog.vue?vue&type=template&id=29f0af26&scoped=true"
import script from "./AssignmentDialog.vue?vue&type=script&lang=js"
export * from "./AssignmentDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDialog.vue?vue&type=style&index=0&id=29f0af26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f0af26",
  null
  
)

export default component.exports